import { FCX } from "@datassential/platform-ui-lib";
import Tabs from "@components/Tabs";
import { useSelectedKeywordsContext } from "@vms/SelectedKeywords/SelectedKeywordsContext";

const SelectedKeywordsViewsTabs: FCX = ({
    className,
}) => {
    const {
        isSelectedKeywordsView,
        setIsSelectedKeywordsView,
    } = useSelectedKeywordsContext();
    return (
        <Tabs
            className={className}
            data={[
                {
                    id: 'all',
                    title: 'All Items',
                },
                {
                    id: 'selected',
                    title: 'Selected Items',
                },
            ]}
            modifiers={["height-l", "item-l"]}
            activeTabId={isSelectedKeywordsView ? 'selected' : 'all'}
            onItemClick={(id: string) => setIsSelectedKeywordsView(id === 'selected')}
        />
    );
};

export default SelectedKeywordsViewsTabs;